import { useState } from 'react';
import { IAssignedUsers, ICaseManagementTask } from '../../../models/cases';
import { IPaginator } from '../../../models/paginator';
import { EPerPages, ISortOptions } from '../../../models/table';
import { getAssignedUsersCase, getCaseManagementTask } from '../../../requests/case';
import { useAlert } from 'models/alertContext';
import { useTranslations } from 'hooks/useTranslations';
import { useNavigate } from 'react-router-dom';

export const useCaseManagementTasks = () => {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const [tasks, setTasks] = useState<ICaseManagementTask[]>([]);
  const [paginator, setPaginator] = useState<IPaginator | null>(null);
  const [assignedUsersCase, setAssignedUsersCase] = useState<IAssignedUsers[]>([]);
  const [paginatorAssignedUsers, setPaginatorAssignedUsers] = useState<IPaginator | null>(
    null,
  );

  const { setAlert } = useAlert();

  const getCaseManagementTasksData = async (
    currentPage: number = 1,
    perPage: EPerPages = EPerPages.perPage25,
    body: Partial<any> = {},
    sort?: ISortOptions | null,
  ) => {
    const result = await getCaseManagementTask(currentPage, perPage, body, sort);
    if (result) {
      const { content, ...paginatorData } = result;
      setTasks(content);
      setPaginator(paginatorData);
    } else {
      setTasks([]);
      setPaginator(null);
    }
  };

  const getAssignedUsersCaseData = async (
    currentPage: number = 1,
    perPage: EPerPages = EPerPages.perPage25,
    body: Partial<any> = {},
    sort?: ISortOptions | null,
  ) => {
    const result = await getAssignedUsersCase(currentPage, perPage, body, sort);
    if (result) {
      const { content, ...paginatorData } = result;
      setAssignedUsersCase(content);
      setPaginatorAssignedUsers(paginatorData);
      return result;
    } else {
      setAssignedUsersCase([]);
      setPaginatorAssignedUsers(null);
      return null;
    }
  };

  return {
    getCaseManagementTasksData,
    tasks,
    paginator,
    getAssignedUsersCaseData,
    assignedUsersCase,
    paginatorAssignedUsers,
  };
};
